import type { IUser } from '@cian/frontend-newbuilding-broker-callback-component';
import { createSlice } from '@reduxjs/toolkit';

import { getUser } from '../../services/getUser';
import { createAppAsyncThunk } from '../../utils/redux/createAppAsyncThunk';

const initialState = {
  active: false,
  loading: false,
  user: {} as IUser,
};

export const fetchUser = createAppAsyncThunk(
  'newbuildingBrokerSelfRequestFormWidget/fetchUser',
  (_, { extra: context }) => {
    return getUser(context);
  },
);

const newbuildingBrokerSelfRequestFormWidgetSlice = createSlice({
  name: 'newbuildingBrokerSelfRequestFormWidget',
  reducers: {
    setNewbuildingBrokerSelfRequestFormWidgetActive: (state, { payload }) => {
      state.active = payload;
    },
    setNewbuildingBrokerSelfRequestFormWidgetLoading: (state, { payload }) => {
      state.loading = payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchUser.fulfilled, (state, { payload }) => {
      state.user = payload ?? {};
    });
  },
  initialState,
});

export const {
  reducer: newbuildingBrokerSelfRequestFormWidgetReducer,
  actions: { setNewbuildingBrokerSelfRequestFormWidgetActive, setNewbuildingBrokerSelfRequestFormWidgetLoading },
} = newbuildingBrokerSelfRequestFormWidgetSlice;
